<template>
    <!--================Header Area =================-->
    <div class="header_area">
        <div class="container-flow">
            <nav class="navbar navbar-expand-lg navbar-light">
                <!-- Brand and toggle get grouped for better mobile display -->
                <router-link tag="div" class="navbar-brand logo_h" :to="{name: 'Hello'}" activeClass='active' exact >
                  <img :src="logolarge" alt="" height=60>
                </router-link>
                <!-- <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                </button> -->
                <!-- Collect the nav links, forms, and other content for toggling -->
                <!-- <div class="collapse navbar-collapse offset" id="navbarSupportedContent">
                    <ul class="nav navbar-nav menu_nav ml-auto">
                        <router-link v-for="(nav, index) in nav_list" :key="index" tag="li" class="nav-item" :to="{name: nav.path}" activeClass='active'>
                          <div class="nav-link">{{ nav.name }}</div>
                        </router-link>
                        <li class="nav-item submenu dropdown">
                            <a href="#" class="nav-link dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">Blog</a>
                            <ul class="dropdown-menu">
                                <li class="nav-item"><a class="nav-link" href="blog.html">Blog</a></li>
                                <li class="nav-item"><a class="nav-link" href="blog-single.html">Blog Details</a></li>
                            </ul>
                        </li> 
                        <li class="nav-item"><a class="nav-link" href="elements.html">Elemests</a></li>
                    </ul>
                </div>  -->
            </nav>
        </div>
    </div>
    <!--================Header Area =================-->
</template>

<script>
import logolarge from '@/assets/2020logoSS.png'
export default {
  name: 'headers',
  data () {
    return {
      nav_list: [
        {name: '房型', path: 'Room'},
        {name: '訂房須知', path: 'Know'},
        {name: '聯絡我們', path: 'Contact'},
        {name: '最新消息', path: 'News'},
        {name: '周邊旅遊', path: 'Travel'}
      ]
    }
  },
  methods: {
  },
  computed: {
    logolarge () {
      return logolarge
    }
  },
  mounted () {
    // console.log(this.$route.name)
  }
}
</script>

<style lang="scss">
.navbar {
  z-index: 5;
  padding: 0 !important;
  box-shadow: 0px 1px 10px #222;
  .navbar-brand {
    padding: 0;
    img {
      height: 80px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/HeaderV2.vue